import { render } from "./CodeReviewPushes.vue?vue&type=template&id=d2cb31da&scoped=true"
import script from "./CodeReviewPushes.vue?vue&type=script&lang=js"
export * from "./CodeReviewPushes.vue?vue&type=script&lang=js"

import "./codeReview.css?vue&type=style&index=0&id=d2cb31da&scoped=true&lang=css&external"
import "./CodeReviewPushes.vue?vue&type=style&index=1&id=d2cb31da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2cb31da"]])

export default __exports__